<div
  class="min-h-screen grid grid-cols-1 md:grid-cols-2 p-0 bg-cover bg-no-repeat bg-center bg-none md:bg-[url('/Background.svg')]"
>
  <!-- Left panel (Card) -->

  <div
    class="bg-white rounded-0 md:rounded-3xl shadow-lg p-10 lg:p-10 md:p-5 lg:m-12 md:m-5 sm:m-0 xl:m-15 2xl:m-30"
  >
    <!-- Logo -->
    <div
      class="flex items-start justify-center md:justify-start gap-3 lg:min-h-[133px] sm:min-h-[50px] md:min-h-[85px]"
    >
      <img src="/logo.svg" alt="plandag logo" class="h-10" />
      <span
        class="text-4xl font-semibold tracking-tight text-[#00165A] flex justify-center md:justify-start"
        >plandag</span
      >
    </div>

    <div class="content-container sm:pr-2">
      <div class="space-y-2 mb-6">
        <h1
          class="md:text-3xl text-2xl md:my-1 my-4 font-medium md:font-bold text-[#00165A] flex justify-center md:justify-start"
        >
          {{ i18n.t('login') }}
        </h1>
        <p class="text-sm text-slate-600 flex justify-center md:justify-start">
          {{ i18n.t('welcomeMessage') }}
        </p>
      </div>

      <form class="form-container" [formGroup]="passwordForm">
        <div class="mb-4">
          <app-input
            (keydown.enter)="$event.preventDefault()"
            formControlName="email"
            [submitted]="submitted"
            [isReadonly]="true"
            [showEdit]="true"
            (onEditClick)="editPassword()"
            [label]="i18n.t('email')"
            labelCustomClass="block mb-1 font-medium text-gray-700"
            inputCustomClass="border border-gray-300 rounded-md px-3 h-[42px] w-full"
          >
          </app-input>
        </div>
        <div class="mb-4">
          <app-password
            #passwordRef
            formControlName="password"
            [label]="i18n.t('password')"
            [submitted]="submitted"
            class="password"
            labelCustomClass="block mb-1 font-medium text-gray-700"
            inputCustomClass="border border-gray-300 rounded-md px-3 h-[42px] w-full"
          ></app-password>

          <div class="flex justify-start mt-3">
            <a
              tabindex="0"
              (keydown.enter)="onForgotPassword()"
              class="text-md font-medium text-[#00165A] hover:text-blue-700 hover:underline focus:outline-none focus:text-blue-700 focus:underline cursor-pointer transition-colors duration-200"
              (click)="onForgotPassword()"
            >
              {{ i18n.t('forgotPassword') }}
            </a>
          </div>
        </div>

        <div class="flex items-center gap-2 pt-2 pb-10"></div>
        <div class="w-full">
          <app-button
            [label]="i18n.t('login')"
            type="submit"
            [loading]="loading"
            (click)="onLogin()"
            severity="info"
            customClass="w-full custom-dark-blue"
          ></app-button>
        </div>

        <!-- <p class="text-xs text-slate-600 pt-1 flex justify-start mt-8">
          Having trouble signing in?
          <a class="text-sky-700 hover:underline" href="#">Reset password</a>
        </p> -->
      </form>
    </div>
  </div>

  <!-- Right panel (Background + Marketing) -->
  <div class="hidden md:flex items-center justify-center">
    <div class="relative z-10 max-w-lg text-center space-y-8">
      <h2 class="text-4xl font-extrabold leading-tight text-[#00165A]">
        The simplest way to manage<br />your workforce
      </h2>

      <!-- Budget Card -->

      <div class="mt-4 flex items-center flex-col justify-center">
        <!-- Semi-Gauge -->

        <p-carousel
          [value]="products"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="true"
          [autoplayInterval]="3000"
          class="mt-4 mx-auto max-w-4xl w-full"
          contentClass="flex justify-center"
        >
          <ng-template pTemplate="item" let-product>
            <div class="m-2 p-4 w-full flex justify-center">
              <div class="bg-white rounded-2xl shadow-md p-6 w-full max-w-[360px]">
                <div class="text-[#00165A] font-semibold mb-3">
                  {{ product.name }}
                </div>
                <img
                  [src]="product.image"
                  [alt]="product.name"
                  class="w-full h-[165px] object-contain rounded-md mx-auto"
                />
              </div>
            </div>
          </ng-template>
        </p-carousel>

        <p class="mt-4 text-xs text-slate-600 text-center">
          Empower your team with a management tool built for speed, simplicity, and control. From
          budget tracking to workflow automation, everything works seamlessly together so you can
          focus on growth, not administration.
        </p>
      </div>

      <!-- Dots -->
    </div>
  </div>
</div>
